export enum ETheme {
  LIGHT = 'light',
  DARK = 'dark',
}
